<template>
  <a v-if="text"
     :title="text"
     class="info ml-2"
     v-b-tooltip.hover.html>
    <InfoSvg class="info-svg"/>
  </a>
</template>

<script setup>
import InfoSvg from "@/assets/svg-vue/general/question.svg.vue"

defineProps({
  text: {
    type: String,
    required: true
  }
})
</script>

<style scoped lang="scss">
.info {
  cursor: help;
}
.info-svg {
  width: 14px;
  height: 14px;
}
</style>
